import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageMetaData from "../../PageMetaData/PageMetaData";
import OgMetaTitles from "../../PageMetaData/OgMetaTitles";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import EditNewUiSearchFormHotels from "../NewUiSearchForm/NewUiSearchFormHotels/EditNewUiSearchFormHotels";
import Skeleton from "react-loading-skeleton";
import GetDirectionRedirect from "../../GetDirectionRedirect/GetDirectionRedirect";
import { Fancybox } from "@fancyapps/ui";
import { formatIndianCurrency } from "../../../utils/utils";
import styles from "./NewAgentSearchPage.module.scss";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import SimilarHotels from "../../SimilarHotels/SimilarHotels";
import NewUISingleHotelRoomCard from "../NewUiHotels/NewUISIngleHotelRoomCard";
import imgNotFound from "../../../assets/images/single-image.png";
import SingleHotelCard from "./SingleHotelCard";
import SingleHotelSearchForm from "./SingleHotelSearchForm";
import AgentSimilarHotels from "./AgentSimiliarHotel";
import NewSingleHotelCard from "./NewSingleHotelCard";
import AgentSideBar from "../../../Pages/Agent/AgentSideBar/AgentSideBar";
import AgentHeader from "../../../Pages/Agent/AgentHeader/AgentHeader";

function NewSingleHotelSearchPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState({});
  const [hotelData, setHotelData] = useState({});
  const { slug, id: hotelId } = useParams();
  const [loader, setLoader] = useState(true);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const agentDiscount = userDetails?.agent_category_discount || 0;
  const agentDiscountType = userDetails?.agent_discount_type || "percentage";

  Fancybox.bind("[data-fancybox]", {
    // Fancybox options if any
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [roomsData, setRoomsData] = useState("");

  const handleRoomsChange = (updatedRooms) => {
    setRoomsData(updatedRooms);
  };
  // Extract date parts
  const today = new Date();

  const tomorrow = new Date(today); // Clone 'today' instead of modifying it
  tomorrow.setDate(tomorrow.getDate() + 1);
  const checkinDay = today.getDate();
  const checkinMonth = today.getMonth() + 1; // Month is 0-indexed
  const checkinYear = today.getFullYear();

  const checkoutDay = tomorrow.getDate();
  const checkoutMonth = tomorrow.getMonth() + 1;
  const checkoutYear = tomorrow.getFullYear();

  // console.log(bookingData, "bookingData");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    if (!slug || !hotelId) {
      // Optional fallback UI or message
      console.warn("Missing slug or hotelId, skipping fetch.");
      return;
    }

    const data = {
      slug,
      hotelId,
      location: params.get("location") || "",
      room: params.get("room") || "1",
      adult: params.get("adult") || "2",
      children: params.get("children") || "0",
      checkinDay: params.get("checkinDay") || checkinDay,
      checkinMonth: params.get("checkinMonth") || checkinMonth,
      checkinYear: params.get("checkinYear") || checkinYear,
      checkoutDay: params.get("checkoutDay") || checkoutDay,
      checkoutMonth: params.get("checkoutMonth") || checkoutMonth,
      checkoutYear: params.get("checkoutYear") || checkoutYear,
      hotel_name: params.get("hotel_name") || "",
      hotel_address: params.get("hotel_address") || "",
      childAge: childAges,
    };

    setBookingData(data);
    postBookingData(data);
  }, [location.search, slug, hotelId]);

  const postBookingData = async (data) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    const formdata = new FormData();
    formdata.append("checkIn", checkInDate);
    formdata.append("checkOut", checkOutDate);
    formdata.append("adults", data.adult);
    formdata.append("child", data.children);
    formdata.append("rooms", data.room);
    formdata.append("PropertyType", "hotel");
    formdata.append("hotel_name", data.hotel_name);
    formdata.append("slug", data.slug);
    formdata.append("hotelId", data.hotelId);

    if (Array.isArray(data.childAge) && data.childAge.length > 0) {
      data.childAge.forEach((age, index) => {
        formdata.append(`childAge[${index + 1}]`, age);
      });
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hotel-engine/check-availability`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setHotelData(result.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  const [hotelAmenities, setHotelAmenities] = useState(false);
  const firstRoom = hotelData?.rooms?.[0];
  const firstMealPlan = firstRoom?.rates?.[0];
  const hotelAddress = hotelData?.hotelInfo?.address
    ? `${hotelData?.hotelInfo?.name}, ${hotelData?.hotelInfo?.address}, ${hotelData?.hotelInfo?.city}, ${hotelData?.hotelInfo?.state}, ${hotelData?.hotelInfo?.country}`
    : "";

  const encodedAddress = hotelAddress ? encodeURIComponent(hotelAddress) : "";

  const mapSrc = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;

  const [filter, setFilter] = useState("RoomDetails");
  const [activeFilter, setActiveFilter] = useState("RoomDetails");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };

  const mainFilters = [
    { label: "Rooms & Suites", value: "RoomDetails" },
    { label: "Amenities", value: "HotelAmenities" },
    { label: "About", value: "HotelAbout" },
    { label: "Hotel Location", value: "HotelLocation" },
    { label: "Similar Hotels", value: "SimilarHotels" },
  ];

  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    const section = document.getElementById(sectionValue);
    if (section) {
      const headerHeight =
        document.querySelector("#NewUIHeader")?.offsetHeight || 0;
      const searchFormHeight =
        document.querySelector("#HotelEditSearchForm")?.offsetHeight || 0;
      const totalOffset = headerHeight + searchFormHeight + 44; // Adding extra spacing

      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - totalOffset,
        behavior: "smooth",
      });
    }

    setShowAllTabs(false);
  };

  return (
    <>
      <PageMetaData
        title={`${
          hotelData?.hotelInfo?.name &&
          hotelData?.hotelInfo?.name !== "" &&
          hotelData?.hotelInfo?.name !== undefined &&
          hotelData?.hotelInfo?.name
        } - Mountain Mysteries`}
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />

      {/* <NewUiHeader /> */}
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />
        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />
          {loader ? (
            <div className="">
              <div className="overview-content loading-filter-main">
                <h4 className="SingleHotel-Name">
                  <b>
                    <Skeleton width={100} />
                  </b>
                </h4>
                <small>
                  <Skeleton width={400} />
                </small>
                <p className="SingleHotel-description mb-20">
                  <Skeleton width={200} />
                  {/* <Skeleton width={700} /> */}
                  {/* <Skeleton width={500} /> */}
                </p>

                {Array.from({ length: 1 }).map((_, index) => (
                  <div className="gallery" key={index}>
                    <div>
                      <Skeleton height={350} />
                    </div>
                    <div className="gallery2">
                      <div>
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                    </div>
                  </div>
                ))}

                {Array.from({ length: 5 }).map((_, index) => {
                  return (
                    <div className="single-room-card" key={index}>
                      <div
                        className="card_head flex"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="agent">
                          <h4>
                            <Skeleton width={400} />
                          </h4>
                          <div className="flex flex_gap_10">
                            <Skeleton />
                          </div>
                        </div>
                        <div>
                          <Skeleton width={200} />
                        </div>
                      </div>

                      <div className="single_room_data_">
                        <div className="hotel_view_img">
                          <Skeleton height={185} />
                        </div>

                        <div className="rooms_content">
                          {Array.from({ length: 3 }).map((_, index) => {
                            return (
                              <div
                                className="single_room_details"
                                style={{ padding: "6px 18px" }}
                                key={index}
                              >
                                <div>
                                  <p>
                                    <small>
                                      <Skeleton width={200} />
                                    </small>
                                  </p>
                                  <p>
                                    <small>
                                      <Skeleton width={200} />
                                    </small>
                                  </p>
                                </div>
                                <div className="single_room_price">
                                  <div>
                                    <h4>
                                      <Skeleton width={100} />
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="loading-filter-responsive">
                {Array.from({ length: 1 }).map((_, index) => (
                  <div className="gallery" key={index}>
                    <div>
                      <Skeleton height={150} />
                    </div>
                    <div className="gallery2">
                      <div>
                        <Skeleton height={70} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={70} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={70} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={70} />
                      </div>
                    </div>
                  </div>
                ))}
                <h4 className="SingleHotel-Name">
                  <b>
                    <Skeleton width={250} />
                  </b>
                </h4>
                <small>
                  <Skeleton width={180} />
                </small>
                <p className="SingleHotel-description mb-20">
                  <Skeleton width={900} />
                  <Skeleton width={700} />
                  <Skeleton width={500} />
                  <Skeleton width={300} />
                  <Skeleton width={100} />
                </p>
              </div>
            </div>
          ) : (
            <section className="new_ui_bg  mt-20">
              <div className={styles.SingleHotelPage}>
                <div className={styles.outer_container}>
                  <div className={styles.SingleHotelPageInfo}>
                    <div className="flex align_items_center px-10 flex_wrap flex_gap_5">
                      {" "}
                      <h4>{hotelData?.hotelInfo?.name}</h4>{" "}
                      <div className={styles.Rating}>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7 0.5L8.5716 5.33688H13.6574L9.5429 8.32624L11.1145 13.1631L7 10.1738L2.8855 13.1631L4.4571 8.32624L0.342604 5.33688H5.4284L7 0.5Z"
                            fill="#fff"
                          />
                        </svg>
                        {hotelData?.hotelInfo?.star_rating
                          ? Number(hotelData?.hotelInfo?.star_rating)
                          : 0}{" "}
                        Star
                      </div>
                    </div>
                    <GetDirectionRedirect
                      address={hotelData?.hotelInfo?.address}
                    >
                      <small>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4.83301 6.66667C4.83301 5.82681 5.16664 5.02136 5.7605 4.4275C6.35437 3.83363 7.15982 3.5 7.99967 3.5C8.83953 3.5 9.64498 3.83363 10.2388 4.4275C10.8327 5.02136 11.1663 5.82681 11.1663 6.66667C11.1663 7.50652 10.8327 8.31197 10.2388 8.90584C9.64498 9.4997 8.83953 9.83333 7.99967 9.83333C7.15982 9.83333 6.35437 9.4997 5.7605 8.90584C5.16664 8.31197 4.83301 7.50652 4.83301 6.66667ZM7.99967 4.5C7.42504 4.5 6.87394 4.72827 6.46761 5.1346C6.06128 5.54093 5.83301 6.09203 5.83301 6.66667C5.83301 7.2413 6.06128 7.7924 6.46761 8.19873C6.87394 8.60506 7.42504 8.83333 7.99967 8.83333C8.57431 8.83333 9.12541 8.60506 9.53174 8.19873C9.93807 7.7924 10.1663 7.2413 10.1663 6.66667C10.1663 6.09203 9.93807 5.54093 9.53174 5.1346C9.12541 4.72827 8.57431 4.5 7.99967 4.5Z"
                            fill="#888888"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M2.34926 5.90471C2.46321 4.52258 3.09274 3.23383 4.11287 2.29436C5.13299 1.35488 6.4691 0.83337 7.85593 0.833374H8.14393C9.53075 0.83337 10.8669 1.35488 11.887 2.29436C12.9071 3.23383 13.5366 4.52258 13.6506 5.90471C13.7774 7.44423 13.3018 8.97288 12.3239 10.1687L9.12859 14.076C8.99185 14.2433 8.81965 14.378 8.62445 14.4705C8.42926 14.5631 8.21594 14.6111 7.99993 14.6111C7.78391 14.6111 7.57059 14.5631 7.3754 14.4705C7.1802 14.378 7.00801 14.2433 6.87126 14.076L3.67593 10.1687C2.698 8.97292 2.22238 7.44424 2.34926 5.90471ZM7.85593 1.83337C6.72025 1.83355 5.62615 2.26073 4.79081 3.03012C3.95546 3.79952 3.43995 4.85487 3.34659 5.98671C3.24099 7.26795 3.63678 8.54016 4.45059 9.53537L7.64593 13.4434C7.68888 13.4959 7.74298 13.5383 7.80432 13.5674C7.86566 13.5965 7.9327 13.6116 8.00059 13.6116C8.06848 13.6116 8.13552 13.5965 8.19686 13.5674C8.2582 13.5383 8.3123 13.4959 8.35526 13.4434L11.5506 9.53537C12.3639 8.53997 12.7592 7.26777 12.6533 5.98671C12.5599 4.85476 12.0443 3.79931 11.2088 3.02989C10.3733 2.26048 9.27905 1.83338 8.14326 1.83337H7.85526H7.85593Z"
                            fill="#888888"
                          />
                        </svg>
                        {hotelData?.hotelInfo?.address}
                      </small>
                    </GetDirectionRedirect>
                  </div>
                  <SingleHotelSearchForm
                    searchType="single_hotel"
                    singleHotelPage={true}
                    singleHotelData={bookingData}
                    handleRoomsChange={handleRoomsChange}
                  />{" "}
                  <div className={`${styles.filter_section}`}>
                    <div className={styles.container_inside}>
                      <div className={styles.filter_wrapper}>
                        {mainFilters.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleScrollToSection(item.value)}
                            className={`${styles.filter_card} ${
                              filter === item.value ? styles.active_filter : ""
                            }`}
                          >
                            {item.label}
                          </div>
                        ))}{" "}
                      </div>
                      {/* <div className={styles.mobile_filter_wrapper}>
                    <div
                      onClick={() => handleTabClick("overview")}
                      className={`${
                        styles.filter_card
                      } flex align_items_center justify_content_center flex_gap_5 ${
                        activeFilter === "overview" ? styles.active_filter : ""
                      }`}
                    >
                      Overview{" "}
                      <svg
                        width="11"
                        height="8"
                        viewBox="0 0 13 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          transition: "transform 0.4s",
                          transform: showAllTabs
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <path
                          d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                          stroke="#009A50"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    {showAllTabs &&
                      mainFilters
                        .filter((item) => item.value !== "overview")
                        .map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleScrollToSection(item.value)}
                            className={`${styles.filter_card} ${
                              activeFilter === item.value
                                ? styles.active_filter
                                : ""
                            }`}
                          >
                            {item.label}{" "}
                          </div>
                        ))}
                  </div> */}
                    </div>
                  </div>
                </div>

                <div className="">
                  <div id="RoomDetails">
                    <h4 className={styles.single_hotel_page_heading}>
                      Rooms & Suites
                    </h4>
                    <NewSingleHotelCard
                      rooms={hotelData}
                      bookingData={bookingData}
                      agentDiscount={agentDiscount}
                    />
                  </div>

                  <div id="HotelAmenities">
                    {hotelData?.hotelInfo?.hotel_amenities?.property_amenity
                      ?.length > 0 && (
                      <div className={styles.single_hotel_white_wrapper_outer}>
                        <h4 className={styles.single_hotel_page_heading}>
                          Amenities
                        </h4>
                        <ul className={styles.hotel_amenities}>
                          {hotelData?.hotelInfo?.hotel_amenities
                            ?.property_amenity?.length > 0 &&
                            hotelData.hotelInfo?.hotel_amenities.property_amenity.map(
                              (item, index) => (
                                <li key={index}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="19"
                                    viewBox="0 0 18 19"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_5983_7981"
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="18"
                                      height="19"
                                    >
                                      <rect
                                        y="0.500122"
                                        width="18"
                                        height="18"
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_5983_7981)">
                                      <path
                                        d="M7.93605 11.1096L6.1938 9.36719C6.08993 9.26344 5.95936 9.21031 5.80211 9.20781C5.64499 9.20544 5.51205 9.25856 5.4033 9.36719C5.29468 9.47594 5.24036 9.60769 5.24036 9.76244C5.24036 9.91719 5.29468 10.0489 5.4033 10.1577L7.46149 12.2159C7.59711 12.3514 7.7553 12.4191 7.93605 12.4191C8.1168 12.4191 8.27499 12.3514 8.41061 12.2159L12.5832 8.04325C12.687 7.93938 12.7401 7.80881 12.7426 7.65156C12.745 7.49444 12.6919 7.3615 12.5832 7.25275C12.4745 7.14413 12.3427 7.08981 12.188 7.08981C12.0332 7.08981 11.9015 7.14413 11.7927 7.25275L7.93605 11.1096ZM9.0018 16.6249C8.0163 16.6249 7.08999 16.4379 6.22286 16.0639C5.35574 15.6899 4.60149 15.1824 3.96011 14.5413C3.31874 13.9001 2.81093 13.1462 2.43668 12.2794C2.06255 11.4127 1.87549 10.4866 1.87549 9.50125C1.87549 8.51575 2.06249 7.58944 2.43649 6.72231C2.81049 5.85519 3.31805 5.10094 3.95918 4.45956C4.6003 3.81819 5.35424 3.31038 6.22099 2.93613C7.08774 2.562 8.0138 2.37494 8.99918 2.37494C9.98468 2.37494 10.911 2.56194 11.7781 2.93594C12.6452 3.30994 13.3995 3.8175 14.0409 4.45863C14.6822 5.09975 15.1901 5.85369 15.5643 6.72044C15.9384 7.58719 16.1255 8.51325 16.1255 9.49863C16.1255 10.4841 15.9385 11.4104 15.5645 12.2776C15.1905 13.1447 14.6829 13.8989 14.0418 14.5403C13.4007 15.1817 12.6467 15.6895 11.78 16.0638C10.9132 16.4379 9.98718 16.6249 9.0018 16.6249ZM9.00049 15.4999C10.6755 15.4999 12.0942 14.9187 13.2567 13.7562C14.4192 12.5937 15.0005 11.1749 15.0005 9.49994C15.0005 7.82494 14.4192 6.40619 13.2567 5.24369C12.0942 4.08119 10.6755 3.49994 9.00049 3.49994C7.32549 3.49994 5.90674 4.08119 4.74424 5.24369C3.58174 6.40619 3.00049 7.82494 3.00049 9.49994C3.00049 11.1749 3.58174 12.5937 4.74424 13.7562C5.90674 14.9187 7.32549 15.4999 9.00049 15.4999Z"
                                        fill="#333333"
                                      />
                                    </g>
                                  </svg>
                                  {item}
                                </li>
                              )
                            )}
                        </ul>
                      </div>
                    )}
                  </div>
                  {hotelData?.hotelInfo?.content?.length > 0 && (
                    <div id="HotelAbout">
                      <div className={styles.single_hotel_white_wrapper_outer}>
                        <h4 className={styles.single_hotel_page_heading}>
                          About Property
                        </h4>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: hotelData?.hotelInfo?.content,
                          }}
                        ></p>
                      </div>
                    </div>
                  )}
                  {hotelAddress && hotelAddress?.length > 0 && (
                    <div id="HotelLocation" className="pb_20">
                      <div className={styles.single_hotel_white_wrapper_outer}>
                        <h4 className={styles.single_hotel_page_heading}>
                          Location
                        </h4>
                        {hotelAddress ? (
                          <iframe
                            src={mapSrc}
                            width="100%"
                            height="350"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          ></iframe>
                        ) : (
                          <p>Location details not available</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          <div id="SimilarHotels">
            <AgentSimilarHotels
              filterId={bookingData?.hotelId}
              hotelLocation={hotelData?.hotelInfo?.city}
            />
          </div>
        </div>
      </div>
      {/* <NewFooterUI /> */}
    </>
  );
}

export default NewSingleHotelSearchPage;
